import { render, staticRenderFns } from "./CategorySaleTerm.vue?vue&type=template&id=e1c7010a&"
import script from "./CategorySaleTerm.vue?vue&type=script&lang=js&"
export * from "./CategorySaleTerm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports